<div class="card">
  <div class="card-body">
    <div class="col-12">
      <div class="row">
        <div class="col-12 col-xl col-md-6">
          <div class="form-group " >
            <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
            <select [(ngModel)]="dgcGraphFilter['ay']" class="form-control custom-selectbox w-100">
              <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-xl col-md-6">
          <div class="form-group" >
            <label>{{ 'header.state' | translate }}<span class="required-field">*</span></label>
            <select [(ngModel)]="dgcGraphFilter['lu']" class="form-control custom-selectbox w-100">
              <option value="" [disabled]="true">{{ 'tabledataforstates.selectstate' | translate }}</option>
              <option  value="All">{{ 'tabledataforstates.all' | translate }}</option>
              <option  *ngFor="let state of statelists" value="{{state['uuid']}}">{{'tabledataforstates.' + state['name'] | translate }}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-xl col-md-6" *ngIf="dgcGraphFilter['lu'] == 'All'">
          <div class="form-group" >
            <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span></label>
            <select [(ngModel)]="dgcGraphFilter['month']" class="form-control custom-selectbox">
              <option value="" [disabled]="true">{{'dataSubs.selectmonth' | translate}}</option>
              <option  *ngFor="let month of monthsList"  [value]="month.key">
                {{'monthmaps.' + month['value'] | translate}}</option>
            </select>
          </div>
        </div>        
        <div class="form-group">
          <label class="w-100">&nbsp;&nbsp;<span class="required-field"></span></label>
          <button class="btn btn-info pointer" (click)="getGraphData()" type="submit">{{'dataSubs.VIEW' | translate}}</button>         
        </div>  
      
    </div>

    <div id="double-column-chart" class="mt-5 pointer" *ngIf="showTwoCharts"></div>
    <hr class="bg-dark" *ngIf="showTwoCharts">
    <div id="line-chart" *ngIf="showTwoCharts"  class="mt-5 pointer"></div>
    <div id="single-column-chart" class="mt-5 pointer" *ngIf="!showTwoCharts"></div>

    </div>
    </div>
  </div>
  
  <ng-template #viewModal>
    <div class="modal-header border-0 m-0">
      <h2 style="text-align:center">{{'listofdgc.List of DGCs' | translate}} {{'listofdgc.' + dgcNamesList['type'] | translate}}</h2>
      <!-- in {{titleCase(dgcNamesList['name'])}}  -->      
      <button type="button" (click)="CloseVideoModal()" class="close pointer text-black">
        <span class="text-dark">x</span>
      </button>
    </div>
    <div class="modal-body p-0">
        <table class="table table-sm table-dark m-0">
          <thead>
            <tr class="text-center">
              <th>{{'dataSubs.sno' | translate}}</th>
              <th>{{'dataSubs.DGC Names' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dgc of dgcNamesList['DGCsList'];let i=index">
              <td>{{i+1}}</td>
              <td>{{'districtsdata.' + dgc | translate}}</td>
            </tr>
          </tbody>
        </table>
    </div>
  </ng-template>

